<template>
  <div>
    <b-row>
      <b-col>
        <b-card title="Actualizar informacion del agente">
          <b-card-body>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.name" class="form-control" placeholder="Nombres">
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.phone" class="form-control" placeholder="Telefono">
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.email" class="form-control" placeholder="Email">
                  </b-col>
                </b-row>

              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.identification" class="form-control" placeholder="Identificacion">
                  </b-col>
                </b-row>

                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.password" class="form-control" placeholder="Contraseña">
                  </b-col>
                </b-row>

                <b-row class="form-group">
                  <b-col md="">
                    <input v-model="user.account_number" class="form-control" placeholder="Numero de cuenta">
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="">
                    <b-button variant="primary" class="btn-block" @click="updateUser">ACTUALIZAR INFORMACION</b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card title="Actualizar imagen del agente">
          <b-card-body>
            <b-row>
              <b-col>
                <input type="file" @change="uploadFile($event)">
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import uploadFile from "@/util/uploadFile";

export default {
  name: "Detail_Dashboard",
  props: {
    user: {
      default: {
        _id: null,
        name: null,
        email: null,
        phone: null,
        identification: null,
        role: 'client',
        password: null,
        account_number: null,
        agent_id: null,
        photo: null
      }
    }
  },
  data() {
    return {
      agents: []
    }
  },
  methods: {
    async uploadFile(e) {
      const file = e.target.files[0];
      const {data} = await uploadFile.upload(
        "users/update-photo-agent",
        {
          _id: this.user._id,
          file: file
        }
      );
      console.log("data ", data);
      this.user.photo = data
    },
    updateUser() {
      if (this.user.name !== null && this.user.email !== null && this.user.phone !== null && this.user.identification !== null &&
        this.user.role !== null) {
        post("users/update", {
          _id: this.user._id,
          name: this.user.name.toUpperCase().trim(),
          email: this.user.email.trim(),
          phone: this.user.phone.trim(),
          identification: this.user.identification.trim(),
          password: this.user.password !== null && this.user.password!== ''? this.user.password.trim(): null,
          account_number: this.user.account_number !== null && this.user.account_number!== '' ? this.user.account_number.trim(): null,
          agent_id: this.user.agent_id
        }, true).then(({data}) => {
          this.$emit('reloadData')
          this.showMessage('Informacion guardada')
        })
      } else {
        this.showMessage('Todos los campos son requeridos', 'error')
      }
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    }
  },
}
</script>

<style scoped>

</style>

